/* eslint-disable */
import React from 'react';
import getUrlExtension from '@src/utils/get-url-extension';
import { withoutProps } from '@src/utils/data-utils';
import extendAppend from '@src/components/modal/__helper__/extend-append';
import styles from './index.less';
import Link from '@src/components/link';
import cx from 'classnames';
import ModalContainer from '@src/components/modal-container';
import Button, { buttonType } from '@src/components/button';
import rootStore from '@src/mobx-store/root-store';
const { globalStore } = rootStore;

@extendAppend({ modalClassName: styles.modal })
class Video extends React.PureComponent {
  /**
   * 是否是 m3u8
   * @returns {boolean}
   */
  isM3u8() {
    const { src } = this.props;
    const { m3u8 = src.search('.m3u8') > 0 } = this.props;
    return m3u8;
  }

  getSpreadProps() {
    return withoutProps(this.props, ['generalPlayerIframeUrl', 'm3u8PlayerIframeUrl', 'src', 'modal', 'isModalCloseVisible']);
  }

  /**
   * 渲染除了 m3u8 以外的视频
   * @returns {*}
   */
  renderGeneralPlayer() {
    const { src, generalPlayerIframeUrl, modal, modalContainerClassName, closeCb, borderColor } = this.props;
    return this.renderIframe({
      src: `${generalPlayerIframeUrl}?${encodeURIComponent(
        JSON.stringify({
          video: src,
          autoPlay: true /* m3u8 目前不提供自动播放支持 */
        })
      )}`,
      modal,
      modalContainerClassName,
      closeCb,
      borderColor
    });
  }

  /**
   * 渲染 m3u8 视频
   * @returns {*}
   */
  renderM3u8PlayerIframeUrl() {
    const { src, m3u8PlayerIframeUrl, modal, closeCb, borderColor } = this.props;
    return this.renderIframe({
      src: `${m3u8PlayerIframeUrl}?url=${encodeURIComponent(src)}`,
      modal,
      closeCb,
      borderColor
    });
  }

  renderIframe(props) {
    const { modal, src, wrapIframeClassName, wrapCloseClassName, modalContainerClassName, closeCb, borderColor } = props;
    return (
      <React.Fragment>
        <ModalContainer modalState={modal.visible}>
          <div className={cx(styles.videoContainer, modalContainerClassName)} style={{ borderColor }}>
            <iframe src={src} className={cx(styles.iframe, styles.videoBox, wrapIframeClassName)} allow="autoplay" {...this.getSpreadProps()} />
          </div>
          {modal && (
            <Button
              buttonType={buttonType.ROTATE}
              className={cx(styles.close, wrapCloseClassName)}
              onClick={() => {
                modal.onClose();
                // 关闭视频后，如果背景音乐最近一次有播放，则继续播放
                globalStore.toggleBgmState(globalStore.lastBgmState);
                closeCb && closeCb();
              }}
            />
          )}
        </ModalContainer>
      </React.Fragment>
    );
  }

  render() {
    return this.isM3u8() ? this.renderM3u8PlayerIframeUrl() : this.renderGeneralPlayer();
  }
}

const _append = Video.append;

Video.append = function(...rest) {
  // 视频播放时，关闭背景音乐
  globalStore.recordLastBgmState();
  globalStore.toggleBgmState(false);
  return _append.apply(this, rest);
};

export default Video;

Video.defaultProps = {
  generalPlayerIframeUrl: '//static-web.amazingseasuncdn.com/xassets/iframe/video/0.0.5/index.html',
  m3u8PlayerIframeUrl: '//static-web.amazingseasuncdn.com/xassets/iframe/m3u8-media-play/0.0.5/index.html',
  width: '100%',
  height: '100%',
  frameBorder: 0,
  allowFullScreen: true
};
